import { Link } from "react-router-dom"
import { ANNOUNCEMENTDETAIL, ROOT } from "../../routes/routes_name"
import useAnnouncement from "./useAnnaouncement"
import DOMPurify from "dompurify";
import LimitedText from "../../components/limited_text";

const AnnouncementPage = () => {
    const {
        data,
        isLoading,
    } = useAnnouncement()
    return (
        <div id="body" className="index-page">
            <header id="header" className="header d-flex align-items-center fixed-top">
                <div className="header-container container-fluid container-xl position-relative d-flex align-items-center justify-content-between py-3">
                    <a href={ROOT} className="logo d-flex align-items-center me-auto me-xl-0">
                        <h1 className="sitename"><img src="assets/img/ppg.png" alt="" srcSet="" /></h1>
                    </a>
                    <Link to={ROOT} className="btn-getstarted"><i className="bi bi-chevron-left"></i> Kembali</Link>
                </div>
            </header>
            <main className="main">
                <div className="page-title light-background">
                    <div className="container">
                        <h1>Pengumuman</h1>
                        <nav className="breadcrumbs">
                            <ol>
                                <li><a href={ROOT}>Home</a></li>
                                <li className="current">Pengumuman</li>
                            </ol>
                        </nav>
                    </div>
                </div>
                <section id="announcement" className="news section">
                    <div className="container">
                        <div className="row gy-3" >
                            {
                                isLoading ? <div className="text-center">Loading...</div> :
                                    !data ? <div className="text-center">Data tidak ditemukan</div> :
                                        data.map((d, i) => {
                                            return (
                                                <div key={i} className="col-lg-3 col-md-12 col-sm-12">
                                                    <div className="card w-100" style={{ width: "18rem" }}>
                                                        <img src={d.thumbnail} className="card-img-top" alt="..." />
                                                        <div className="card-body">
                                                            <h5 className="card-title">{d.judul}</h5>
                                                            <div className="card-text"
                                                                dangerouslySetInnerHTML={{
                                                                    __html: DOMPurify.sanitize(LimitedText({ text: d.konten, limit: 50 })),
                                                                }}
                                                            />
                                                            <Link to={ANNOUNCEMENTDETAIL} state={d} className="read-more">Selengkapnya <i className="bi bi-arrow-right"></i> </Link>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })
                            }

                        </div>
                    </div>

                </section>
            </main>
        </div>
    )
}
export default AnnouncementPage